import { ALL } from "../constants"
import * as ActionTypes from "../constants/actionTypes"
import { UPDATE_PDF_CONSTITUENTS } from "../constants/actionTypes"
import { IPdfTemplates } from "../interfaces/IPdfTemplate"

function init() {
	return {} as IPdfTemplates
}

export const pdfTemplateReducer = (state = init(), action: any): IPdfTemplates => {
	switch (action.type) {
		case UPDATE_PDF_CONSTITUENTS:
			return action.payload
		default:
			return state
	}
}
